import list from './list'
import gps from './gps'
import funds from './funds'
import transforms from './transforms'
import styles from './styles'
import validators from './validators'

export default {
    list,
    gps,
    funds,
    'funds-perf': funds,
    companies: funds,
    trans: funds,
    'trans-perf': funds,
    'companies-evol': funds,
    transforms,
    styles,
    validators,
}
